document.addEventListener( 'DOMContentLoaded', function () {
	const mobileMenuToggle = document.getElementById( 'mobile-menu-toggle' );
	const mobileMenu = document.getElementById( 'mobile-menu' );
	const mobileMenuBackdrop = document.getElementById(
		'mobile-menu-backdrop'
	);
	const hamburgerIcon = document.getElementById( 'hamburger-icon' );
	const closeIcon = document.getElementById( 'close-icon' );
	const header = document.querySelector( '.header' );
	const body = document.body;

	let isMenuOpen = false;

	// Calculate and set header height
	function setHeaderHeight() {
		if ( header ) {
			const headerHeight = header.offsetHeight;
			document.documentElement.style.setProperty(
				'--header-height',
				`${ headerHeight }px`
			);
		}
	}

	// Set initial header height and update on resize
	setHeaderHeight();
	window.addEventListener( 'resize', setHeaderHeight );

	function openMenu() {
		if ( isMenuOpen ) return;

		isMenuOpen = true;

		// Transform button icons
		if ( hamburgerIcon && closeIcon ) {
			hamburgerIcon.classList.add( 'hidden' );
			closeIcon.classList.remove( 'hidden' );
		}

		// Show backdrop
		mobileMenuBackdrop.style.pointerEvents = 'auto';
		mobileMenuBackdrop.classList.remove( 'opacity-0' );
		mobileMenuBackdrop.classList.add( 'opacity-100' );

		// Show menu
		mobileMenu.classList.remove( 'translate-x-full' );
		mobileMenu.classList.add( 'translate-x-0' );

		// Prevent body scroll
		body.style.overflow = 'hidden';
	}

	function closeMenu() {
		if ( ! isMenuOpen ) return;

		isMenuOpen = false;

		// Transform button icons back
		if ( hamburgerIcon && closeIcon ) {
			hamburgerIcon.classList.remove( 'hidden' );
			closeIcon.classList.add( 'hidden' );
		}

		// Hide backdrop
		mobileMenuBackdrop.style.pointerEvents = 'none';
		mobileMenuBackdrop.classList.remove( 'opacity-100' );
		mobileMenuBackdrop.classList.add( 'opacity-0' );

		// Hide menu
		mobileMenu.classList.remove( 'translate-x-0' );
		mobileMenu.classList.add( 'translate-x-full' );

		// Restore body scroll
		body.style.overflow = '';
	}

	// Event listeners
	if ( mobileMenuToggle ) {
		mobileMenuToggle.addEventListener( 'click', function ( e ) {
			e.preventDefault();
			e.stopPropagation();

			if ( isMenuOpen ) {
				closeMenu();
			} else {
				openMenu();
			}
		} );
	}

	// Close menu when clicking backdrop
	if ( mobileMenuBackdrop ) {
		mobileMenuBackdrop.addEventListener( 'click', function ( e ) {
			e.preventDefault();
			closeMenu();
		} );
	}

	// Close menu on escape key
	document.addEventListener( 'keydown', function ( e ) {
		if ( e.key === 'Escape' && isMenuOpen ) {
			closeMenu();
		}
	} );

	// Close menu when clicking on menu links
	const menuLinks = mobileMenu?.querySelectorAll( 'a[href]' );
	if ( menuLinks ) {
		menuLinks.forEach( ( link ) => {
			link.addEventListener( 'click', function () {
				// Small delay to allow navigation to start
				setTimeout( closeMenu, 100 );
			} );
		} );
	}

	// Handle window resize - close menu if screen becomes large
	window.addEventListener( 'resize', function () {
		if ( window.innerWidth >= 1024 && isMenuOpen ) {
			// lg breakpoint
			closeMenu();
		}
	} );

	// Prevent menu content clicks from bubbling to backdrop
	if ( mobileMenu ) {
		mobileMenu.addEventListener( 'click', function ( e ) {
			e.stopPropagation();
		} );
	}
} );
